import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnCameraStatusHistorical } from './camera-status-historical';

export class SnCameraStatusHistoricalList extends SnModel {
  @Expose()
  public count: number;

  @Expose()
  public next: string;

  @Expose()
  public previous: string;

  @Expose()
  public results: SnCameraStatusHistorical[];

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
